<template>
  <div class="ima-transfer-modal">
    <button class="button is-info" type="button" v-for="option in options" :key="option" @click="onSelect(option)">
      <span class="icon">
      </span>
      <span>{{getPrettyLabel(option)}}</span>
    </button>

  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
import { getTransferOptions } from '@/services/permissions'
import { transferSign } from '@/store/modules/sign'
import { closeModals } from '@/store/modules/modals'
import modals from '@/mixins/modals'

export default {
  name: 'ima-transfer-modal',
  data () {
    return {}
  },
  computed: {
    ...mapState(['sign', 'status']),
    options: getTransferOptions
  },
  mixins: [modals],
  methods: {
    ...mapActions([transferSign]),
    ...mapMutations([closeModals]),
    onSelect (status) {
      this.transferSign(status).then(sign => {
        this.closeModals()
      })
    },
    getPrettyLabel (statusName) {
      switch (statusName) {
        case 'ABGESCHLOSSEN':
          return 'Abschließen'
        case 'BEI PM-ADMIN':
          return 'An PM-Admin weitergeben'
        case 'BEI ÜBERSETZER':
          return 'An Übersetzer weitergeben'
        case 'BEI IMA':
          return 'An IMA weitergeben'
        default:
          return 'Weitergeben'
      }
    }
  }
}
</script>

<style lang="scss">
.ima-transfer-modal {
  display: flex;
  flex-direction: column;

  button {
    margin: 0.2rem auto;
    min-width: 25rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modals/TransferModal.vue